export default () => {
    return {
        animating: false,

        // π ----
        // :: MOUNTED ---------------------------::
        // ____
        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            gsap.set(this.$refs.arrowClone01, { yPercent: 104 })
            gsap.set(this.$refs.arrowClone02, { yPercent: 104 })
            this.animating = true
            let stSettings = false

            if (scrollTrigger) {
                stSettings = {
                    trigger: this.$refs.button,
                    toggleActions: 'play none play none',
                }
            }

            const open = gsap.timeline({
                scrollTrigger: stSettings,
                onComplete: () => {
                    this.animating = false
                    if (this.$refs.bg02) {
                        this.$refs.bg02.classList.add('z-10')
                    }
                },
            })

            if (this.$refs.bg02) {
                open.fromTo(
                    this.$refs.bg02,
                    { xPercent: -104 },
                    { duration: 0.4, delay: delay, xPercent: 0, ease: 'circ.inOut' },
                )
            }
            if (this.$refs.bg01) {
                open.fromTo(
                    this.$refs.bg01,
                    { xPercent: -104 },
                    { duration: 0.4, xPercent: 0, delay: 0.2, ease: 'circ.inOut' },
                )
            }
            if (this.$refs.arrow) {
                open.fromTo(
                    this.$refs.arrow,
                    { yPercent: 104 },
                    { duration: 0.3, yPercent: 0, ease: 'circ.inOut' },
                    '<0.2',
                )
            }
            if (this.$refs.label) {
                open.fromTo(
                    this.$refs.label,
                    { yPercent: -104, opacity: 0 },
                    { duration: 0.5, yPercent: 0, opacity: 1, ease: 'circ.inOut' },
                    '<-0.2',
                )
            }
            if (this.$refs.bg02) {
                open.set(this.$refs.bg02, { xPercent: -104 })
            }
        },

        // π ----
        // :: HOVER ---------------------------::
        // ____
        hover() {
            if (!this.animating) {
                this.animating = true

                const tl = gsap.timeline({
                    onComplete: () => {
                        this.animating = false
                    },
                })

                tl.addLabel('start')
                if (this.$refs.arrow) {
                    tl.fromTo(this.$refs.arrow, { yPercent: 0 }, { duration: 0.5, yPercent: -104, ease: 'circ.inOut' })
                }
                if (this.$refs.arrowClone01) {
                    tl.fromTo(
                        this.$refs.arrowClone01,
                        { yPercent: 104 },
                        { duration: 0.5, yPercent: 0, ease: 'circ.inOut' },
                        'start',
                    )
                }
                if (this.$refs.background) {
                    tl.to(this.$refs.background, { duration: 0.5, scale: 1.25, ease: 'circ.inOut' }, 'start')
                }
                if (this.$refs.bg02) {
                    tl.to(this.$refs.bg02, { duration: 0.7, xPercent: 0, ease: 'expo.inOut' }, 'start')
                }
            }
        },

        leave() {
            this.animating = true

            const tl = gsap.timeline({
                onComplete: () => {
                    this.animating = false
                },
            })

            tl.addLabel('start')
            if (this.$refs.arrowClone01) {
                tl.to(this.$refs.arrowClone01, { duration: 0.5, yPercent: -104, ease: 'circ.inOut' })
            }
            if (this.$refs.arrowClone02) {
                tl.fromTo(
                    this.$refs.arrowClone02,
                    { yPercent: 104 },
                    { duration: 0.5, yPercent: 0, ease: 'circ.inOut' },
                    'start',
                )
            }
            if (this.$refs.bg02) {
                tl.to(this.$refs.bg02, { duration: 0.7, xPercent: 104, ease: 'expo.inOut' }, 'start')
            }
            tl.to(this.$refs.background, { duration: 0.5, scale: 1, ease: 'circ.inOut' }, 'start')
            if (this.$refs.bg02) {
                tl.set(this.$refs.bg02, { xPercent: -104 })
            }
            tl.set(this.$refs.arrow, { yPercent: 0 }).set(this.$refs.arrowClone02, { yPercent: 104 })
        },
    }
}
